// Light Theme - Based on DESIGN_NOTES.md Minimal Landing Style
export const lightTheme = {
  name: 'light',

  colors: {
    // Background colors
    background: {
      primary: '#ffffff', // Main background (cards, modals)
      secondary: '#fafafa', // Page background, hover states
      tertiary: '#f5f5f5', // Alternative background
      hover: '#fafafa', // Hover state background
      disabled: '#f9f9f9', // Disabled elements background
      page: '#fafafa' // ContentStyle.Content background
    },

    // Text colors
    text: {
      primary: '#000000', // Main text, titles
      secondary: '#333333', // Body text
      tertiary: '#666666', // Labels, secondary info
      muted: '#999999', // Placeholder text, disabled text
      disabled: '#aaaaaa', // Disabled text
      inverse: '#ffffff' // Text on dark backgrounds
    },

    // Border colors
    border: {
      light: '#f0f0f0', // Card separators, subtle borders
      medium: '#e0e0e0', // Input borders, card borders
      strong: '#d0d0d0', // Strong borders, active states
      focus: '#000000' // Focus state borders
    },

    // Semantic colors (actions, states)
    semantic: {
      primary: '#000000', // Primary actions (black buttons)
      success: '#22c55e', // Success actions, add buttons
      successHover: '#f0fdf4', // Success button hover background
      danger: '#DC2626', // Delete, error actions
      warning: '#EA580C', // Warning states
      info: '#2563EB', // Info states
      secondary: '#6B7280' // Secondary actions
    },

    // Shadow colors
    shadow: {
      light: 'rgba(0, 0, 0, 0.04)', // Card shadow default
      medium: 'rgba(0, 0, 0, 0.08)', // Card shadow hover
      strong: 'rgba(0, 0, 0, 0.12)', // Modal shadow
      overlay: 'rgba(0, 0, 0, 0.3)', // Modal overlay
      focus: 'rgba(0, 0, 0, 0.15)' // Button focus shadow
    },

    // Scrollbar colors
    scrollbar: {
      track: '#fafafa', // Scrollbar track background
      thumb: '#d0d0d0', // Scrollbar thumb
      thumbHover: '#999999', // Scrollbar thumb hover
      thumbActive: '#666666' // Scrollbar thumb active
    },

    // Chart colors (for analytics/charts compatibility)
    primary: {
      main: '#2563EB',
      light: '#60A5FA',
      dark: '#1E40AF'
    },
    success: {
      main: '#22c55e',
      light: '#4ade80',
      dark: '#16a34a'
    },
    danger: {
      main: '#DC2626',
      light: '#EF4444',
      dark: '#B91C1C'
    },
    warning: {
      main: '#EA580C',
      light: '#F97316',
      dark: '#C2410C'
    },
    info: {
      main: '#2563EB',
      light: '#60A5FA',
      dark: '#1E40AF'
    }
  },

  // Typography
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    fontSize: {
      cardTitle: '1rem',
      label: '0.75rem',
      input: '0.875rem',
      button: '0.875rem'
    },
    fontWeight: {
      cardTitle: 500,
      label: 400,
      button: 500
    },
    letterSpacing: {
      cardTitle: '-0.01em'
    }
  },

  // Spacing (based on DESIGN_NOTES.md optimizations)
  spacing: {
    cardPadding: '1.25rem', // Reduced from 1.75rem
    cardPaddingMobile: '1rem',
    cardHeaderMargin: '1rem', // Reduced from 1.5rem
    cardHeaderPadding: '0.625rem', // Reduced from 0.875rem
    buttonMargin: '0.75rem', // Reduced from 1.25rem
    formGap: '1rem',
    gridGap: '1rem'
  },

  // Border radius
  radius: {
    card: '12px',
    input: '6px',
    button: '6px',
    icon: '7px'
  },

  // Transitions
  transitions: {
    default: 'all 0.2s ease',
    button: 'all 0.3s ease'
  }
}
